module.exports = __webpack_public_path__ + "img/save40.15ea4327.svg";